import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';

import Typography from 'components/ui/Typography';
import Icon from 'components/Icon';
import Tile from 'components/ui/Tile';
import { SpriteIcon } from 'types/icons';

import css from './Menu.module.scss';

export interface MenuItem {
    title: string;
    route: string;
    icon: React.ReactNode;
}

interface Props {
    menu: MenuItem[];
}

const Menu: React.FC<Props> = ({ menu }) => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <Tile>
            {menu.map((item) => {
                const isActive = `${location.pathname}${location.search}` === item.route;

                return (
                    <div
                        key={item.route}
                        className={clsx(css.item, isActive && css.isActive)}
                        onClick={() => navigate(item.route)}
                    >
                        <Icon name={item.icon as SpriteIcon} width={18} color={isActive ? 'white' : 'blue'} />
                        <Typography style="BodyMedSemibold" color={isActive ? 'white' : 'blue'}>
                            {item.title}
                        </Typography>
                    </div>
                );
            })}
        </Tile>
    );
};

export default React.memo(Menu);
